import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosInstance5000 from '../services/5000AxiosInstance'; // Import the axios instance
import axios8000 from '../services/8000AxiosInstance';
import Snackbar from './Snackbar'; // Import Snackbar component

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [processing, setProcessing] = useState(false); // State for processing indicator

  const pageStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    background: '#000',
    color: '#fff',
    fontFamily: 'Arial, sans-serif',
    margin: 0,
    padding: 0,
    boxSizing: 'border-box',
  };

  const containerStyle = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    alignItems: 'center',
    background: '#111',
    padding: '20px',
    borderRadius: '10px 0px 0px 0px',
    boxShadow: '0 0 20px 10px rgba(143, 0, 255, 0.5)',
    width: '100%',
    maxWidth: '599px',
    height: '605px',
    textAlign: 'center',
    margin: '85px auto',
    boxSizing: 'border-box',
  };

  const formStyle = {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  };

  const inputStyle = {
    width: '100%',
    padding: '10px',
    margin: '10px 0',
    border: '1px solid #333',
    borderRadius: '5px',
    background: '#222',
    color: '#fff',
    boxSizing: 'border-box',
  };

  const buttonStyle = {
    width: '100%',
    padding: '10px',
    margin: '10px 0',
    border: 'none',
    borderRadius: '5px',
    background: 'linear-gradient(90deg, rgba(58,29,132,1) 0%, rgba(123,36,203,1) 100%)',
    color: '#fff',
    cursor: processing ? 'not-allowed' : 'pointer', // Disable cursor if processing
    opacity: processing ? 0.6 : 1, // Dim button if processing
    boxSizing: 'border-box',
  };

  const linkStyle = {
    color: '#a2a2ff',
    textDecoration: 'none',
  };

  const optionsStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '10px 0',
  };

  const handleLogin = async () => {
    setProcessing(true); // Set processing state to true
    try {
      const response = await axios8000.post('/login/', {
        email,
        password,
      });

      const { message, user_id, api_key } = response.data;
      sessionStorage.setItem('user_id', user_id);
      sessionStorage.setItem('api_key', api_key);
      setSnackbarMessage(`Login successful!\nUser ID: ${user_id}`);
      setTimeout(() => {
        setSnackbarMessage('');
        navigate('/dashboard');
      }, 3000);
    } catch (error) {
      const errorMsg = error.response?.data?.message || 'Login failed. Please try again.';
      setSnackbarMessage(errorMsg);
      setTimeout(() => setSnackbarMessage(''), 3000);
    } finally {
      setProcessing(false); // Reset processing state
    }
  };

  return (
    <div style={pageStyle}>
      <div style={containerStyle}>
        <h2>Log In</h2>
        <form
          style={formStyle}
          onSubmit={(e) => {
            e.preventDefault();
            if (!processing) handleLogin();
          }}
        >
          <input
            type="email"
            placeholder="Email Id"
            style={inputStyle}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={processing} // Disable input during processing
          />
          <input
            type="password"
            placeholder="Password"
            style={inputStyle}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            disabled={processing} // Disable input during processing
          />
          <div style={optionsStyle}>
            <label>
              <input type="checkbox" disabled={processing} /> Remember me
            </label>
            <a href="/forgotpassword" style={linkStyle}>
              Forgot password?
            </a>
          </div>
          <button type="submit" style={buttonStyle} disabled={processing}>
            {processing ? 'Processing...' : 'Log In'}
          </button>
        </form>
        <p>
          Don't have an account? <a href="/signup" style={linkStyle}>Sign Up</a>
        </p>
      </div>
      {snackbarMessage && <Snackbar message={snackbarMessage} />}
    </div>
  );
};

export default Login;